/*
 * Copyright (c) 2022 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';

interface Props {
  index: number;
  ctxId: number | string;
}

export default function FillingCard({ index, ctxId }: Props): JSX.Element {
  return (
    <div
      key={index}
      style={{ width: '100%', height: 'auto', display: 'flex' }}
      className="content-card-cell small filling-card"
      id={`FillingCard___${ctxId}-${index}`}
    >
      <a
        className="context-switch filling-content-card content-card small single-line"
        style={{ width: '100%', height: 'auto' }}
      >
        <div className="border-radius-container card-wrapper">
          <div className="content-card-image" />
          <div className="content-card-info" />
        </div>
      </a>
    </div>
  );
}
